import MerchantDetailsPage from './MerchantDetailsPage';

export default MerchantDetailsPage;
